import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'DynamicDecimalPipe',
    standalone: true
})

export class DynamicDecimalPipe implements PipeTransform {
    private noDecimalCurrencies: string[] = ['jpy', 'krw'];

    transform(value: any, currencyCode: string): string {
        // console.log("typeof value",typeof value);
        if (typeof value === 'string' && value.includes(',')) {
            value = Number(value.replace(/,/g, ''));
        }
        if (typeof value === "undefined" || !value) {
            value = 0;
        }
        if (this.noDecimalCurrencies.includes(currencyCode)) {
            // value = Math.ceil(value);

            return new Intl.NumberFormat(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value);
        }

        return new Intl.NumberFormat(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(value);
    }
}